import { render, staticRenderFns } from "./overseaBillDetail.vue?vue&type=template&id=015beaa3&"
import script from "./overseaBillDetail.vue?vue&type=script&lang=js&"
export * from "./overseaBillDetail.vue?vue&type=script&lang=js&"
import style0 from "./overseaBillDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015beaa3')) {
      api.createRecord('015beaa3', component.options)
    } else {
      api.reload('015beaa3', component.options)
    }
    module.hot.accept("./overseaBillDetail.vue?vue&type=template&id=015beaa3&", function () {
      api.rerender('015beaa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Act/overseaBillDetail.vue"
export default component.exports